<template>
  <NextReviewerModal
    ref="modal"
    :asyncSelectOptions="getInspectorOptions"
    :okBtnAction="'confirm'"
    :okBtnDisabled="!selectedValue"
    :title="'Please Select Inspector'"
    @onOkClick="save"
  >
    <template
      v-if="showInspectorEmptyHint"
      slot="add-text"
    >
      <p class="error-hint">
        {{ $t('hint.noInspector') }}
      </p>
    </template>
  </NextReviewerModal>
</template>

<script>
import { ref, unref, computed } from 'vue-demi'
import NextReviewerModal from '@/controls/Modal/NextReviewerModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { getProjectInspector } from '@/api/projects/request'
import { useRouteParamId } from '@/router/useRouter'
import mutationTypes from '@/store/mutation-types'
import { useStoreMutations } from '@/store/index'

export default {
  emit: ['updateAfterSave'],
  components: {
    NextReviewerModal,
  },
  props: {
    nextActionAfterSave: {
      type: Function,
      default: undefined,
    },
    submissionIndex: {
      type: Number,
      default: 0,
    },
  },
  setup (props) {
    const { open, modal } = useRefModal()
    const projectId = useRouteParamId()
    const { updateField } = useStoreMutations('projects', { updateField: mutationTypes.UPDATE_PATH_FIELD })

    const showInspectorEmptyHint = ref(false)
    const selectedValue = computed(() => {
      return unref(modal) ? unref(modal).getSelectedValue() : ref('')
    })

    const save = async () => {
      const basicPath = ['submissions', props.submissionIndex, 'invoice']
      updateField({ path: [...basicPath, 'inspectedBy'], newValue: JSON.parse(unref(selectedValue)).id })
      await props.nextActionAfterSave()
    }

    const getInspectorOptions = async () => {
      const result = await getProjectInspector(unref(projectId)) || []
      showInspectorEmptyHint.value = !result.length
      return result.map(item => ({ name: `${item.displayName} (${item.username})`, value: { id: item.id, username: item.username } }))
    }

    return {
      getInspectorOptions,
      open,
      modal,
      showInspectorEmptyHint,
      selectedValue,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
.error-hint {
    color: red;
}
</style>
